import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {DamageReport} from '../../../models/models';
import {Translation} from '../../../models/translation';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {DamageAdministrationService} from '../../../services/damage-administration.service';
import {forkJoin} from 'rxjs';
import {ClickEventArgs} from '@syncfusion/ej2-angular-navigations';
import {GridComponent, RowDataBoundEventArgs} from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-damagereports',
  templateUrl: './damagereports.component.html',
  styleUrls: ['./damagereports.component.css']
})
export class DamagereportsComponent implements OnInit {

  @ViewChild('damageAdministrationReportGrid', {static: true}) private damageAdministrationReportGrid: GridComponent;

  public translation: Translation;
  public locale: string;
  public dataSource: DamageReport[] = [];
  public formatOptions: any;

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
    private router: Router,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(12);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.loadDataSource();
  }

  loadDataSource() {
    const list = this.damageAdministrationService.getReceivers();
    const carTypeList = this.damageAdministrationService.getCarTypes();
    const jobTypeList = this.damageAdministrationService.getJobTypes();
    const employeeList = this.damageAdministrationService.getEmployees();
    const damageReportList = this.damageAdministrationService.getDamageReportsInsertedByCustomer();
    forkJoin([list, carTypeList, jobTypeList, employeeList, damageReportList]).subscribe((result: any) => {
      result[4].forEach(d => {
        let lookup;
        lookup = result[1].Obj.find(c => c.CarTypeId === d.Type);
        d.CarTypeDisplayName = lookup !== undefined ? lookup.CarTypeName : '';
        lookup = result[2].Obj.find(j => j.JobTypeId === d.JobType);
        d.JobTypeDisplayName = lookup !== undefined ? lookup.JobTypeName : '';
        lookup = result[0].Obj.find(r => r.ReceiverId === d.Receiver);
        d.ReceiverDisplayName = lookup !== undefined ? lookup.ReceiverName : '';
        lookup = result[0].Obj.find(r => r.ReceiverId === d.Receiver);
        d.WorkshopDisplayName = lookup !== undefined ? lookup.ReceiverName : '';
        lookup = result[3].Obj.find(r => r.UniqueId === d.CausedBy);
        d.CausedByDisplayName = lookup !== undefined ? lookup.LastName : '';
      });
      this.dataSource = result[4];
      this.initGrid();
    });
  }

  initGrid() {
    this.damageAdministrationReportGrid.allowExcelExport = true;
    this.damageAdministrationReportGrid.allowPdfExport = true;
    this.damageAdministrationReportGrid.allowPaging = true;
    this.damageAdministrationReportGrid.pageSettings = {pageCount: 5, pageSize: 20};
    this.damageAdministrationReportGrid.toolbar = ['ExcelExport', 'PdfExport', 'Print', 'Search'];
    this.damageAdministrationReportGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
  }

  rowDataBound(args: RowDataBoundEventArgs) {
    // @ts-ignore
    if (args.data.CheckDocStateDone) {
      args.row.classList.add('greenLine');
      // @ts-ignore
    } else if (args.data.CheckDocStateRelease) {
      args.row.classList.add('blueLine');
      // @ts-ignore
    } else if (args.data.CheckDocStateIncomplete) {
      args.row.classList.add('redLine');
    }
  }

  openDamageAdministrationRecord($event: MouseEvent) {
    // @ts-ignore
    this.router.navigate(['/damageAdministrationRecord', $event.rowData.DocNum]);
  }

  toolbarClick($event: ClickEventArgs) {
    if ($event.item.id === 'damageAdministrationOverviewGrid_excelexport') {
      this.damageAdministrationReportGrid.excelExport();
    }
    if ($event.item.id === 'damageAdministrationOverviewGrid_pdfexport') {
      this.damageAdministrationReportGrid.pdfExport();
    }
  }
}
